<template>
  <div

      :id="randomId"
      :data-testid="
      props.dataTestid
        ? props.dataTestid + '_faq-accordion-section'
        : '_faq-accordion-section  '
    "
  >
    <slot name="header">
      <TsTypography
          v-if="props.title"
          :appendClass="twMerge('text-xl text-idle-black font-semibold font-gilroy',props.titleClass)"
          :data-testid="`${props.dataTestid}_title`"
          variant="p"
          :align="titleAlign"
          as="h2"
      >
        {{ props.title }}
      </TsTypography>
    </slot>

    <TsAccordion
        append-class="px-4 mx-auto border rounded-lg border-natural-light-grey mt-4 mb-0"
    >
      <TsAccordionTab
          v-for="(item, index) in previewData"
          :data-testid="`${props.dataTestid}_accordion`"
          :append-class="twMerge(
              'first:border-t-0 px-0',
              index === previewData.length - 1 && 'border-b-0'
          )"
          active-class="border-b-0"
          :body-class="twMerge(
              'px-0',
              index === previewData.length - 1 && 'border-b-0'
          )"
      >
        <template #heading="{isOpen}">
          <TsTypography
              as="h2"
              :variant="isMobile ? 'h4' : 'h5'"
              :append-class="twMerge('mb-0 font-medium', isOpen && 'font-bold')"
              :data-testid="`${props.dataTestid}_heading_${index}`"
          >
            <span v-if="props.isNumbering">Q.{{ index + 1 }}&nbsp;</span>{{ item.heading }}
          </TsTypography>
        </template>
        <TsTypography
            as="p"
            append-class="mb-0"
            :data-testid="`${props.dataTestid}_content`"
            :text="item.content"
        />
      </TsAccordionTab>
    </TsAccordion>
    <slot name="footer">
      <div v-if="props.content.length > 5" class="text-center mt-4">
        <TsButton
            :label="`${viewMore ? useTranslation('viewLess', 'Bekijk minder') : useTranslation('viewMore', 'Bekijk meer')}`"
            @click="viewMore = !viewMore"
            :data-testid="`${props.dataTestid}_button`"
        />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useRandomUUID } from "../../composables/useRandomUUID";
import { onMounted, ref } from "vue";
import {twMerge} from "tailwind-merge";

const TsAccordion = defineAsyncComponent(
    () => import('~/components/atoms/TsAccordion.vue')
);
const TsAccordionTab = defineAsyncComponent(
    () => import('~/components/atoms/TsAccordionTab.vue')
);

const { isMobile } = useDevice();

// random ID for each Vue Instance
const randomId = ref<string>("");

const viewMore = ref(false)

onMounted(() => {
  randomId.value = useRandomUUID();
});

type Props = {
  title?: string;
  buttonLabel?: string;
  content?: object[];
  dataTestid?: string;
  isNumbering?: boolean;
  titleClass?:string;
  titleAlign?: 'left' | 'center' | 'right' | 'justify';
};

const props = withDefaults(defineProps<Props>(), {
  title: "FAQ",
  titleAlign: "center",
  isNumbering: true,
  content: () => [
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.1",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.2",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.3",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.4",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.5",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.6",
    },
    {
      heading: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ?",
      content:
          "Ans. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      qno: "Q.7",
    },
  ],
});
 
const previewData = computed(() => viewMore.value ? props.content : props.content.slice(0, 5))
schemaFAQs(props.content)
</script>
